module.exports = __webpack_public_path__ + "img/clearcheck-white.b08cea0c.svg";